// extracted by mini-css-extract-plugin
export default {"transform_cont_main":"Transform_transform_cont_main__bdH3O","transform_child":"Transform_transform_child__icN1H"};